
import { AppInsightsAnalytics, AppInsightsConfiguration } from 'etna-client-analytics/dist/etna-client-analytics.min';


export class Analytics {

    constructor(connectionString){
        const config = new AppInsightsConfiguration("",connectionString);
        AppInsightsAnalytics.setEnabled(true);
        AppInsightsAnalytics.setup(config);
        this.config = config;
    }

    setUser(userId, username){
        this.config.authenticatedUserId = username;
        this.config.accountID = userId;
        AppInsightsAnalytics.setup(this.config);   
        AppInsightsAnalytics.setEnabled(true);
    }


}